<script>
export default {
  name: "MkContact"
}
</script>

<template>
  <div>
  <v-card class="card">
    <v-card-title>Работно време</v-card-title>
    <v-card-text>
      Понеделник-Петок: 07-18
    </v-card-text>
  </v-card>
  <v-card class="card">
    <v-card-title>Телефони за нарачки</v-card-title>
    <v-card-text>
      <a href="tel:+38977707253">077/707-253</a> <br/>
      <a href="tel:+38923224461">02/3224-461</a>
    </v-card-text>
  </v-card>
  </div>
</template>

<style scoped>
.card{
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.3rem;
  margin: 2rem auto;
  max-width: 18rem;
  text-align: center;
}
a{
  text-decoration: none;
}
</style>